import React from 'react'
import { FormGroup } from './'
import { PopoverIcon } from 'shared'
import { StarredField } from 'shared'

export const HolderFields = () => (
  <div className="donations-form-holder">
    <div className="flex">
      <StarredField name="first_name" placeholder={i18n.t('donate.attributes.first_name')} component={FormGroup} />
      <StarredField name="last_name" placeholder={i18n.t('donate.attributes.last_name')} component={FormGroup} />
    </div>

    <div className="input-with-popover">
      <StarredField name="email" type="email" placeholder={i18n.t('donate.attributes.email')} component={FormGroup} />
      <PopoverIcon i18nKey={'donate.email_popover'} popoverId="tooltip-for-email" />
    </div>
  </div>
)
